'use client';

import { useState } from 'react';
import Icon from '@/components/ui/AppIcon';

interface ComparisonFeature {
  feature: string;
  basic: boolean;
  standard: boolean;
  premium: boolean;
}

interface ServiceComparisonProps {
  features: ComparisonFeature[];
}

export default function ServiceComparison({ features }: ServiceComparisonProps) {
  const [isHydrated, setIsHydrated] = useState(false);

  useState(() => {
    setIsHydrated(true);
  });

  if (!isHydrated) {
    return (
      <section className="py-16 bg-muted">
        <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="font-headline font-bold text-3xl md:text-4xl text-primary mb-4">
              Service Comparison
            </h2>
          </div>
          <div className="bg-card rounded-lg p-8 shadow-brand animate-pulse">
            <div className="h-96 bg-muted rounded-lg" />
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="py-16 bg-muted">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="font-headline font-bold text-3xl md:text-4xl text-primary mb-4">
            Service Comparison
          </h2>
          <p className="font-body text-lg text-muted-foreground">
            Choose the service level that best fits your needs
          </p>
        </div>
        
        <div className="bg-card rounded-lg shadow-brand overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="bg-primary text-primary-foreground">
                  <th className="py-4 px-6 text-left font-headline font-bold">Feature</th>
                  <th className="py-4 px-6 text-center font-headline font-bold">Basic</th>
                  <th className="py-4 px-6 text-center font-headline font-bold">Standard</th>
                  <th className="py-4 px-6 text-center font-headline font-bold">Premium</th>
                </tr>
              </thead>
              <tbody>
                {features.map((item, index) => (
                  <tr 
                    key={index}
                    className={`border-b border-border ${index % 2 === 0 ? 'bg-background' : 'bg-muted/30'}`}
                  >
                    <td className="py-4 px-6 font-body text-foreground">{item.feature}</td>
                    <td className="py-4 px-6 text-center">
                      {item.basic ? (
                        <Icon name="CheckIcon" variant="solid" size={24} className="text-success mx-auto" />
                      ) : (
                        <Icon name="XMarkIcon" size={24} className="text-muted-foreground mx-auto" />
                      )}
                    </td>
                    <td className="py-4 px-6 text-center">
                      {item.standard ? (
                        <Icon name="CheckIcon" variant="solid" size={24} className="text-success mx-auto" />
                      ) : (
                        <Icon name="XMarkIcon" size={24} className="text-muted-foreground mx-auto" />
                      )}
                    </td>
                    <td className="py-4 px-6 text-center">
                      {item.premium ? (
                        <Icon name="CheckIcon" variant="solid" size={24} className="text-success mx-auto" />
                      ) : (
                        <Icon name="XMarkIcon" size={24} className="text-muted-foreground mx-auto" />
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  );
}